import React, { useEffect, useState } from 'react'
import AdapterJalali from '@date-io/date-fns-jalali';
import constants from "../../constants/constants";
import './style.scss'
import { ToPersianNumber, CommaSeparator, DateToPersianNumber, toEnglishNumber } from "../../functions";
import moment from 'moment';
import momentFa, { now } from 'moment-jalaali'
import { getAllInvoice, insertInvoice, updateOfficialFactors, getAllInvoiceReserved, getInvoiceReservedById, GetFinancialPeriods, getNewStatusAllMovadianInvoice, getReturnedOrRevokedFactors } from "../../api/requestAxios/invoice";
import { ErrorToast, InfoToast, Loading } from "../../shared/index";
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import Modal from "react-bootstrap/Modal";
import DownloadSCV from "./downloadSCV";
import { DrowpDown } from "../../assets/images/svg/icon"
import InvoiceTable from "./invoiceTable";
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { DateRangePicker, DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import DownloadSCVFromPending from './downloadSCVFromPending';
import GetReturnAndRevoke from './revokeReturn/getReturnAndRevoke'
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook';
import ModalInfo from './reserveInvoice/modalInfo';
import { getProvince } from '../../api/requestAxios/userInfo';

const InvoicelList = (props) => {
    const [data, setData] = useState({ pageSize: 100, disablePaging: true, data: [] })
    const [dataCopy, setDataCopy] = useState({ pageSize: 100, disablePaging: true, data: [] })

    const [loading, setLoading] = useState(false)
    const [lastFactorNumber, setLastFactorNumber] = useState()
    const [lastFactorDate, setLastFactorDate] = useState()
    const [statusMovadianSelected, setStatusMovadianSelected] = useState('all')
    const [statusSelected, setStatusSelected] = useState(props.selectedStatus ? props.selectedStatus : 5);
    const [objGetData, setObjGetData] = useState({ FromDate: '', ToDate: '', FinancialPeriodId: '' })
    const [idOfNewRow, setIdOfNewRow] = useState('')
    const [show, setShow] = useState(false)
    const [content, setContent] = useState('')
    const [title, setTitle] = useState('')
    const [isCheckedAgain, setIsCheckedAgain] = useState(false);
    const [itemForDownload, setItemForDownload] = useState()
    const [isSVGDownload, setIsSVGDownload] = useState(false)
    const [newReserved, setNewresereved] = useState(false)
    const [downloadPdfOfRow, setDownloadPdfOfRow] = useState(false)
    const [isReservedAddedtoeAcceptInvoice, setIsReservedAddedtoeAcceptInvoice] = useState(false)
    const [rowRejectedInPending, setRowRejectedInPending] = useState()
    const [rowReservedInPending, setRowReservedInPending] = useState()
    const [isDeleted, setIsDeleted] = useState(false)
    const [isReserved, setIsReserved] = useState(false)
    const [myFinancialPeriodsList, setMyFinancialPeriodsList] = useState([])
    const [financialPeriodIdSelected, setFinancialPeriodIdSelected] = useState('')
    const [isParameterChange, setIsParameterChange] = useState(false)
    const [isChangeoption, setIsChangeOption] = useState([])
    const [isexistFinacialYear, setIsexistFinacialYear] = useState(false)
    const [isGoodFinancialYear, setIsGoodFinancialYear] = useState(false)
    const [isCallApi, setIscallApi] = useState(false)
    const [messageEmpty, setMessageEmpty] = useState('')
    const [viewDetail, setviewDetail] = useState(false)
    const [newReserveArr, setNewReserveArr] = useState([])
    const [isInsertSuccessfull, setIsInsertSuccessfull] = useState(false);
    const [isUpdateSuccessfull, setIsUpdateSuccessfull] = useState(false);
    const [isInsert, setIsInsert] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [isNotSave, setIsNotSave] = useState(false)
    const [value, setValue] = useState([null, null]);
    const [checkedList, setCheckedList] = useState([]);
    const [itemInLoading, setItemInLoading] = useState(false)
    const [resendItemInLoading, setResendItemInLoading] = useState(false)
    const [newOptionSelected, setNewOptionSelected] = useState()
    const [reserveCount, setReserveCount] = useState(0)
    const [totalFactorListAmount, setTotalFactorListAmount] = useState()
    const [downloadSCVFromPending, setDownloadSCVFromPending] = useState(false)
    const [isApprove, setIsApprove] = useState(false)
    const [states, setStates] = CustomValuesHook({ originDataToPaging: { data: [] } })
    const [isGetRetuenRevoke, setIsGetRetuenRevoke] = useState(false)
    const [showModalInfo, setShowModalInfo] = useState(false)


    const [infoForm, handleInfoForm] = CustomValuesHook({
        loading: false,
        provinceList: [],
        cityProvince: {},
        cityList: [],
        cityAndProvinceList: [],
        provLoading: false,
    })


    const getMaxDate = (date) => {
        if (!date) {
            return date
        }
        const startTime = new Date(date).getTime()
        const month = date.getMonth();
        const year = date.getFullYear();
        let daysInMonth = new Date(year, month, 0).getDate();
        daysInMonth = daysInMonth + 96
        return new Date(startTime + daysInMonth * 24 * 60 * 60 * 1000)
    }

    const maxDate = React.useMemo(() => getMaxDate(value[0]), [value])



    useEffect(() => {
        GetFinancialPeriodsFn()
    }, [])

    useEffect(() => {
        let start = moment(value[0], 'YYYY-jMM-jDD').isValid()
        let end = moment(value[1], 'YYYY-jMM-jDD').isValid()

        if (start && end && value[0] !== value[1]) {

            setMessageEmpty('')
            let year = findFinantialYear(value[0], value[1])
            if (year) {
                setFinancialPeriodIdSelected(year)
            }
            else {
                // let temp=[...data.data]
                // temp=[]
                // setData(temp)
                ErrorToast('سال مالی انتخاب شده وجود ندارد')
            }


        }
    }, [value])

    useEffect(() => {
        if (isUpdate && isInsert) {
            if (isUpdateSuccessfull && isInsertSuccessfull) {
                InfoToast('تغییرات با موفقیت ثبت شد')
            }
            else if (isUpdateSuccessfull && !isInsertSuccessfull) {
                InfoToast('تغییرات مربوط به ثبت با موفقیت انجام شد و تغییرات مربوط به ویرایش اطلاعات  با مشکل مواجه شد')
            }
            else if (!isUpdateSuccessfull && isInsertSuccessfull) {
                InfoToast('تغییرات مربوط به ویرایش اطلاعات به درستی انجام شد و تغییرات مربوط به ثبت با مشکل مواج شد')
            }
            else if (!isUpdateSuccessfull && !isUpdateSuccessfull) {
                ErrorToast(constants.ServerErroe)
            }
        }
        else if (isUpdate && !isInsert) {
            if (isUpdateSuccessfull) {
                InfoToast('تغییرات مربوط به ویرایش  اطلاعات به درستی انجام شد')
            }
            else {
                ErrorToast(constants.ServerErroe)
            }
        }
        else if (!isUpdate && isInsert) {
            if (isInsertSuccessfull) {
                InfoToast('تغییرات مربوط به ثبت به درستی انجام شد')
            }
            else {
                ErrorToast(constants.ServerErroe)
            }
        }

    }, [isUpdateSuccessfull, isInsertSuccessfull])

    const findFinantialYear = (start, end) => {
        let result = spliteDate(start, end)
        let newYear = ''
        setIsGoodFinancialYear(false)
        setIsexistFinacialYear(false)
        if (result) {
            setIsGoodFinancialYear(true)
            let yearSelected = result.split('-')[0]
            // myFinancialPeriodsList.forEach((item, index) => {6
            //     if (item.Year.trim() === result.trim()) {
            //         newYear = item.FinancialPeriodId
            //         setIsexistFinacialYear(true)
            //     }
            // })
            if (parseInt(yearSelected.trim()) >= 1399 && parseInt(yearSelected.trim()) <= 1408) {
                newYear = myFinancialPeriodsList[0]?.FinancialPeriodId
                setIsexistFinacialYear(true)
            }

        }
        return newYear
    }

    const search = () => {
        if (isexistFinacialYear && isGoodFinancialYear) {
            if (isChangeoption?.length > 0) {
                setIsNotSave(true)
                setTitle('دخیره‌ی اطلاعات')
                setShow(true)
                setContent('تغییرات ذخیره نشده است، آیا تغییرات ذخیره شود؟؟؟؟ (برای ذخیره‌ی تغییرات، دکمه ی تایید کردن، بالای صفحه را بزنید)')
                setNewOptionSelected(statusSelected)//prev
            } else {
                setIscallApi(true)
                setMessageEmpty('')
                setLoading(true)

                if (parseInt(statusSelected) === 4) {
                    getReservedFactor()
                    setLastFactorDate('')
                    setLastFactorNumber('')
                }
                else if (parseInt(statusSelected) === 3) {
                    setLastFactorDate('')
                    setLastFactorNumber('')
                    setTimeout(() => {
                        setIsGetRetuenRevoke(true)
                    }, 1000)

                }
                else {
                    handleGetData()
                }
            }
        } else {
            ErrorToast('سال مالی به درستی انتخاب نشده است')
        }

    }

    const handleSearch = (e) => {
        e.preventDefault()
        setIsApprove(false)
        setIsGetRetuenRevoke(false)
        setReserveCount(0)
        search()

    }

    const spliteDate = (startValue, endValue) => {
        if (startValue || endValue) {
            let startDate = momentFa(startValue).local('fa').format(' jYYYY-jMM-jDD HH:MM')
            let startYear = startDate.split('/')[0]

            let endDate = momentFa(endValue).local('fa').format(' jYYYY-jMM-jDD HH:MM')
            let endYear = endDate.split('/')[0]

            if (endYear || startYear) {
                return endYear
            }
            else {
                return false
            }
        }
        else {
            return false
        }

    }

    const [columns, setColumns] = useState([
        { title: 'ردیف', property: 'row', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'مشترک', property: 'FirstNameAndLastName', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'ایمیل', property: 'Email', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: ' مبلغ', property: 'PayableAmountFa', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'درگاه', property: 'GatewayName', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'تاریخ تراکنش', property: 'PersianIssueDateFa', filterProperty: null, hasSort: false, hasFilter: false, display: true },
        {
            title: 'وضعیت فاکتور', property: 'Status', filterProperty: null,
            rowClassName: [
                { property: 'OfficialFactorType', value: 1, className: "accepted-invoice" },
                { property: 'OfficialFactorType', value: 2, className: "rejected-invoice" },
                { property: 'OfficialFactorType', value: 3, className: "returnedFromSale-invoice" },
                { property: 'OfficialFactorType', value: 4, className: "reserved-invoice" },
                { property: 'OfficialFactorType', value: null, className: "pendingToAccept-invoice" }
            ],
            hasSort: false, hasFilter: false, display: true
        },
        { title: 'گزینه‌ها', property: 'PersianIssueDateFa', filterProperty: null, hasSort: false, hasFilter: false, display: true },

    ])
    //get GetFinancialPeriods
    const GetFinancialPeriodsFn = async () => {
        setLoading(true)
        try {
            const financialPeriodsList = await GetFinancialPeriods()
            setMyFinancialPeriodsList(financialPeriodsList.data)
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            ErrorToast(error)
        }
    }

    //insert resere new invoice in accepted invoice list
    const insertReservedInvoiceFn = async (objData) => {
        setLoading(true)
        setNewReserveArr([])
        setNewresereved(false)
        try {
            setLoading(false)
            // setLastFactorNumber(lastFactorNumber+1)
            const insertresult = await insertInvoice(objData)
            setContent('')
            setTitle('')
            let temp = { ...objGetData }
            temp.OfficialFactorType = 1
            getReservedFactorById(insertresult?.data[0]?.Id)
            setObjGetData(temp)
        }
        catch (error) {
            setLoading(false)
            ErrorToast(error)
        }
    }
    //*******************************************************************************************/
    //insert pending invoice
    const inserDataFn = (e) => {
        e.preventDefault()
        setIsApprove(true)
        setIsReserved(false)
        setIsDeleted(false)
        setShow(true)
        setTitle(constants.SellApprove)
        let approveCount = 0;
        let rejectCount = 0;
        let reserveCount = 0

        data.data.forEach((item, index) => {
            if (item.OfficialFactorType === null) {
                approveCount = approveCount + 1;
            }
            else if (item.OfficialFactorType === 2) {
                rejectCount = rejectCount + 1
            }
            else if (item.OfficialFactorType === 4) {
                reserveCount = reserveCount + 1
            }
        })

        let tempContent = constants.IsApprove + ' ' + '(' + ToPersianNumber(approveCount) + ')' + ' ' + constants.Approved + '، '
            + '(' + ToPersianNumber(rejectCount) + ')' + ' ' + constants.Rejected + 'و '
            + '(' + ToPersianNumber(reserveCount) + ')' + ' ' + constants.Reserveed
            + constants.IsApproveCount
        setContent(tempContent)
    }

    const approveInvoice = (e) => {
        e.preventDefault()
        setShow(false)
        setLoading(true)
        setIsChangeOption([])
        try {
            let arrInsert = []
            let arrUpdate = []
            data.data.forEach((item, index) => {
                if (item.OfficialFactorId) {
                    let objUpdate = {}
                    objUpdate.OfficialFactorId = item.OfficialFactorId
                    objUpdate.OfficialFactorTypeId = item.OfficialFactorType
                    objUpdate.DescriptionReservedOrReturned = item.DescriptionReservedOrReturned
                    arrUpdate.push(objUpdate)
                }
                else {
                    let objInsert = {}
                    objInsert.OfficialFactorType = item.OfficialFactorType
                    objInsert.InvoiceId = item.InvoiceId;
                    objInsert.InvoiceNumberInFactor = item.InvoiceNumberInFactor;
                    objInsert.FinancialPeriodId = financialPeriodIdSelected
                    objInsert.DescriptionReservedOrReturned = item?.DescriptionReservedOrReturned

                    if (item.OfficialFactorType === null) {
                        objInsert.OfficialFactorType = 1
                    }
                    if (item.OfficialFactorType === 4) {
                        delete objInsert.InvoiceId
                        objInsert.FinancialPeriodId = financialPeriodIdSelected
                        objInsert.ReservedFactorDate = item?.IssueDate
                        objInsert.BuyerNameReservedOrReturned = item?.BuyerNameReservedOrReturned
                        objInsert.NationalCodeReservedOrReturned = item?.NationalCodeReservedOrReturned
                        objInsert.TotalAmountReservedOrReturned = item?.TotalAmountReservedOrReturned
                        objInsert.AddressReservedOrReturned = item?.AddressReservedOrReturned
                        objInsert.PhoneReservedOrReturned = item?.PhoneReservedOrReturned
                        objInsert.ResidencePostalCodeReservedOrReturned = item?.ResidencePostalCodeReservedOrReturned
                        objInsert.CityIdReservedOrReturned = item?.CityIdReservedOrReturned
                        objInsert.FactorIssueType = item?.FactorIssueType
                        objInsert.EmailReservedOrReturned = item?.EmailReservedOrReturned


                    }
                    if (item.OfficialFactorType === 2) {
                        delete objInsert.InvoiceNumberInFactor
                    }
                    arrInsert.push(objInsert)
                }
            })

            setIsInsert(false)
            setIsUpdate(false)

            setIsUpdateSuccessfull(false);
            setIsInsertSuccessfull(false);

            if (arrInsert?.length > 0) {
                setIsInsert(true)
                insertDataFn(arrInsert)
            }

            if (arrUpdate?.length > 0) {
                setIsUpdate(true)
                setLoading(true)
                UpdtatDataFn(arrUpdate)
            }
        }
        catch {
            setLoading(false)
            ErrorToast(constants.ServerError)
        }
    }



    const insertDataFn = async (arrInsert) => {
        setLoading(true)
        try {
            const insertresult = await insertInvoice(arrInsert)
            setIsInsertSuccessfull(true)
            setIsInsertSuccessfull(false)

            handleGetData()
        }
        catch {
            setLoading(false)
            ErrorToast(constants.ServerErroe)
        }
    }
    //******************************************************************************************* */
    const getReservedFactorById = async (factorId) => {
        setLoading(true)
        try {
            const dataInvoiceReserved = await getInvoiceReservedById({ FactorId: factorId })
            setLoading(false)
            let myTemp = { ...data }
            let obj = {}
            obj.row = ToPersianNumber(1)
            obj.InvoiceId = "";
            obj.PersianIssueDate = null
            obj.PayableAmount = null
            obj.PersianIssueDate = null
            obj.FirstNameAndLastName = null
            obj.Email = null
            obj.GatewayName = null
            obj.InvoiceNumberInFactor = dataInvoiceReserved.data?.reservedOfficialFactorResponses[0].InvoiceNumberInFactor
            obj.InvoiceNumberInFactorFa = ToPersianNumber(dataInvoiceReserved.data?.reservedOfficialFactorResponses[0].InvoiceNumberInFactor)
            obj.OfficialFactorType = 4
            obj.DescriptionReservedOrReturned = dataInvoiceReserved.data?.reservedOfficialFactorResponses[0].DescriptionReservedOrReturned
            obj.PersianIssueDateFa = '---'
            obj.Status = constants.Reserved
            obj.StatusEn = 'Reserved'
            obj.PayableAmountFa = '---'
            obj.CreatorNameAndFamily = dataInvoiceReserved.data?.reservedOfficialFactorResponses[0].CreatorNameAndFamily
            obj.OfficialFactorCreatePersianDate = DateToPersianNumber(dataInvoiceReserved.data?.reservedOfficialFactorResponses[0].OfficialFactorCreatePersianDate)
            obj.OfficialFactorId = dataInvoiceReserved.data?.reservedOfficialFactorResponses[0]?.OfficialFactorId
            myTemp.data.forEach((item, index) => {
                item.row = index + 2
                item.idTable = index + 1
            })

            myTemp.data.unshift(obj)
            setData({ ...myTemp })
            setIsReservedAddedtoeAcceptInvoice(true)
            InfoToast('فاکتور با موفقیت رزرو شد')
        }
        catch (error) {
            setLoading(false)
            ErrorToast(constants.ServerError)
        }
    }

    //************************************************************************************************************* */
    const getReservedFactor = async () => {
        let temp = { ...objGetData }
        temp.FromDate = moment(new Date(value[0])).local('en').format(' YYYY-MM-DD')
        temp.ToDate = moment(new Date(value[1])).local('en').format('YYYY-MM-DD')
        temp.OfficialFactorType = 4
        // delete temp.FinancialPeriodId
        temp.FinancialPeriodId = financialPeriodIdSelected

        setLoading(true)
        try {
            const dataInvoiceReserved = await getAllInvoiceReserved(temp)
            reservedData(dataInvoiceReserved)

        }
        catch {
            ErrorToast(constants.ServerErroe)

        }
        setLoading(false)
    }
    //************************************************************************************************************** */
    const reservedData = (dataInvoiceReserved) => {
        setLastFactorNumber(dataInvoiceReserved?.data?.LastInvoiceNumberInFactor);
        setLastFactorDate(dataInvoiceReserved?.data?.LastAcceptedFactorPersianDate);
        if (dataInvoiceReserved.data.reservedOfficialFactorResponses?.length === 0) {
            setMessageEmpty(constants.NoExitDataTitle)
            let temp = { ...data }
            temp.data = []
            setData(temp)
        } else {
            setMessageEmpty('')
            let arrTemp = []
            dataInvoiceReserved?.data?.reservedOfficialFactorResponses?.forEach((item, index) => {
                let obj = {}
                obj.row = ToPersianNumber(index + 1)
                obj.InvoiceId = item.InvoiceId;
                obj.PersianIssueDate = null
                obj.PayableAmount = null
                obj.PersianIssueDate = null
                obj.FirstNameAndLastName = '---'
                obj.Email = '----'
                obj.GatewayName = '---'
                obj.InvoiceNumberInFactor = item.InvoiceNumberInFactor
                obj.InvoiceNumberInFactorFa = ToPersianNumber(item.InvoiceNumberInFactor)
                obj.OfficialFactorType = 4
                obj.DescriptionReservedOrReturned = item.DescriptionReservedOrReturned
                obj.PersianIssueDateFa = null
                obj.Status = constants.Reserved
                obj.StatusEn = 'Reserved'
                obj.PayableAmountFa = '----'
                obj.OfficialFactorCreatePersianDate = item?.OfficialFactorCreatePersianDate
                obj.OfficialFactorCreatePersianDateFa = item.OfficialFactorCreatePersianDate ? item.OfficialFactorCreatePersianDate : '---'
                obj.CreatorNameAndFamily = item?.CreatorNameAndFamily ? item?.CreatorNameAndFamily : '---'
                obj.OfficialFactorId = item?.OfficialFactorId
                obj.MoadianTaxId = item?.MoadianTaxId
                obj.MoadianStatus = item?.MoadianStatus
                obj.idTable = index
                arrTemp.push(obj)
            })

            let temp = { ...data }
            temp.data = arrTemp
            setData(temp)
        }


    }
    //************************************************************************************************************** */
    const handleGetData = async () => {
        if (financialPeriodIdSelected !== '' && financialPeriodIdSelected !== null && financialPeriodIdSelected !== undefined) {
            setStatusMovadianSelected('all')

            setLoading(true)
            try {
                let tempObjGetData = { ...objGetData }
                tempObjGetData.FromDate = moment(new Date(value[0])).local('en').format(' YYYY-MM-DD')
                tempObjGetData.ToDate = moment(new Date(value[1])).local('en').format('YYYY-MM-DD')
                delete tempObjGetData.FinancialPeriodId
                // tempObjGetData.FinancialPeriodId = financialPeriodIdSelected
                setObjGetData(tempObjGetData)

                if (parseInt(statusSelected) !== 5) {
                    tempObjGetData.OfficialFactorType = statusSelected
                }
                else {
                    if (tempObjGetData.OfficialFactorType) {
                        delete tempObjGetData.OfficialFactorType
                    }
                }
                const dataInvoice = await getAllInvoice(tempObjGetData)
                setLastFactorNumber(dataInvoice.data.LastInvoiceNumberInFactor)
                setLastFactorDate(dataInvoice.data.LastAcceptedFactorPersianDate)
                setTotalFactorListAmount(dataInvoice.data.TotalFactorListAmount)
                if (parseInt(statusSelected) !== 5) {
                    tempObjGetData.OfficialFactorType = statusSelected
                }
                else {
                    if (tempObjGetData.OfficialFactorType) {
                        delete tempObjGetData.OfficialFactorType
                    }
                }
                if (parseInt(statusSelected) === 1) {
                    if (dataInvoice.data.List === null) {
                        if (dataInvoice.data.ResultStatus === 2) {
                            setLoading(false)
                            ErrorToast(constants.UnseenData + ' ' + DateToPersianNumber(dataInvoice.data.Message) + ' ' + constants.Unseen)
                        }
                        else if (dataInvoice.data.ResultStatus === 3) {
                            ErrorToast(constants.ServerError)
                            setLoading(false)
                        }
                    }
                    else {
                        if (dataInvoice.data.ResultStatus === 1) {
                            setLoading(false)
                            if (dataInvoice.data.List?.length === 0) {
                                let temp = { ...dataInvoice.data }
                                temp.data = []
                                setData({ ...temp })
                                setStates({ originDataToPaging: { ...temp } })
                                setMessageEmpty(constants.NoExitDataTitle)
                            }
                            else {
                                initialData(dataInvoice.data.List, dataInvoice.data.LastInvoiceNumberInFactor)
                            }

                        }
                    }

                }
                else {
                    if (dataInvoice?.data?.List?.length === 0 || !dataInvoice?.data?.List) {
                        setLoading(false)
                        let temp = { ...data }
                        temp.data = []
                        setData(temp)
                        setMessageEmpty(constants.NoExitDataTitle)
                        // ErrorToast(constants.Nodata)
                        if (dataInvoice.data.ResultStatus === 2) {
                            ErrorToast(`از تاریخ ${dataInvoice.data.Message} فاکتور های در انتظار تایید مشاهده نشده است لطفا این تاریخ را به عنوان شروع انتخاب کنید`)
                        }
                    }
                    else {
                        setMessageEmpty('')
                        initialData(dataInvoice.data.List, dataInvoice.data.LastInvoiceNumberInFactor)
                    }
                }
            } catch (error) {
                setLoading(false)
                ErrorToast(error)
            }
        }
        else {

        }
    }


    //************************************************************************************************************* */
    const UpdtatDataFn = async (arr) => {
        setLoading(true)
        setCheckedList([])
        try {
            const dataInvoice = await updateOfficialFactors(arr)
            setIsUpdateSuccessfull(false)
            if (dataInvoice.data.IsSuccess) {
                setLoading(false)
                handleGetData()
                setIsUpdateSuccessfull(true)
            }
        }
        catch (error) {
            setLoading(false)
            ErrorToast(error)
        }

    }
    //************************************************************************************************************* */
    const initialData = (getData, lastNumber) => {

        getData.forEach((item, index) => {
            item.loading = false;
            item.PayableAmountFa = ToPersianNumber(CommaSeparator(item.PayableAmount)) + '‌ ' + constants.Currency
            item.row = ToPersianNumber(index + 1)
            item.idTable = index
            item.PersianIssueDateFa = DateToPersianNumber(item.PersianIssueDate)


            if (item.OfficialFactorType === null && !item.InvoiceNumberInFactor && item.OfficialFactorType !== 2) {
                item.InvoiceNumberInFactor = lastNumber + index + 1 !== null ? lastNumber + index + 1 : '---'
                item.InvoiceNumberInFactorFa = lastNumber !== null ? ToPersianNumber(lastNumber + index + 1) : ''
            }
            else {
                item.InvoiceNumberInFactorFa = item?.InvoiceNumberInFactor ? ToPersianNumber(item?.InvoiceNumberInFactor) : '---'
            }

            switch (item.OfficialFactorType) {
                case 1:
                    item.Status = constants.AcceptedFactor
                    item.StatusEn = 'Accepted'
                    break;
                case 2:
                    item.Status = constants.Rejected
                    item.StatusEn = 'Rejected'
                    break;
                case 3:
                    item.Status = constants.ReturnedFromSale
                    item.StatusEn = 'ReturnedFromSale'
                    break;
                case 4:
                    item.Status = constants.Reserved
                    item.StatusEn = 'Reserved'
                    break;
                case null:
                    item.Status = constants.PendingToAccept
                    item.StatusEn = 'PendingToAccept'
                    break;
                default:
                    break;

            }

        })

        let tempData = [...getData]
        let temp = { ...data }
        temp.data = getData
        setData({ ...temp })
        setStates({ originDataToPaging: temp })
        let filterList = []
        if (statusMovadianSelected !== 'all') {
            tempData.forEach((_item, index) => {
                if (_item.MoadianStatus === statusMovadianSelected) {
                    filterList.push(_item)
                }
            })
            let temp2 = { ...dataCopy }
            temp2.data = filterList
            setDataCopy({ ...temp2 })
        }

        setLoading(false)

    }
    //************************************************************************************************************* */
    const handleChange = (e) => {
        setStatusMovadianSelected('all')
        setIsGetRetuenRevoke(false)
        setReserveCount(0)
        setIscallApi(false)
        setMessageEmpty('')
        let temp2 = { ...data }
        temp2.data = []
        setDataCopy({ ...temp2 })

        if (isChangeoption?.length > 0) {
            setIsNotSave(true)
            setTitle('دخیره‌ی اطلاعات')
            setShow(true)
            setContent('تغییرات ذخیره نشده است، آیا تغییرات ذخیره شود؟؟؟؟ (برای ذخیره‌ی تغییرات، دکمه ی تایید کردن، بالای صفحه را بزنید)')
            setStatusSelected(statusSelected)//prev
            setNewOptionSelected(e.target.value)//new
        }
        else {
            let temp = { ...data }
            temp.data = []
            setData({ ...temp })
            setIsReservedAddedtoeAcceptInvoice(false)
            setIsParameterChange(true)
            setStatusSelected(e.target.value)
        }

    }





    //************************************************************************************************************* */
    const CheckedAgainFn = (e) => {
        e.preventDefault()
        if (checkedList?.length !== 0) {
            setIsCheckedAgain(true)
            setShow(true)
            setTitle(constants.RecheckReason)
            let tempContent = constants.IsApprove + ' ' + '(' + ToPersianNumber(checkedList?.length) + ')' + ' ' + constants.IsApproveCount
            setContent(tempContent)
        }
        else {
            ErrorToast(constants.SelectMinRow)
        }

    }

    //************************************************************************************************************* */
    const downloadFactoeUser = () => {
        setDownloadPdfOfRow(true)
    }

    //************************************************************************************************************* */
    const chechAgain = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setIsInsert(false)
        setIsUpdate(true)
        setIsInsertSuccessfull(false)
        setIsUpdateSuccessfull(false)
        setShow(false)
        let arr = []
        checkedList.forEach((_item, index) => {
            data.data.forEach((item) => {
                if (item.OfficialFactorId === _item) {
                    let obj = {}
                    obj.OfficialFactorId = item.OfficialFactorId;
                    obj.OfficialFactorTypeId = null;
                    obj.DescriptionReservedOrReturned = item.DescriptionReservedOrReturned;
                    arr.push(obj);
                }
            })

        })
        UpdtatDataFn(arr);
    }
    const createCityList = (cityAndProvinceList, provinceCityUser) => {
        if (cityAndProvinceList?.length > 0) {
            let cityListTemp = []

            cityAndProvinceList?.forEach((item, index) => {
                if (item?.Id === provinceCityUser?.provinceId) {
                    let objCity = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id
                    }

                    cityListTemp.push(objCity)
                }
            })
            handleInfoForm({ cityList: cityListTemp })
        }

    }

    const getProv = async (response) => {
        handleInfoForm({ provLoading: true })
        try {
            let preProvince;
            let provinceListTemp = [];
            let cityProvinceTemp = {};

            const listProvinceAndCity = await getProvince()
            listProvinceAndCity?.data?.map((item, index) => {
                //create province list
                if (preProvince !== item.ProvinceName && !item.Delete) {
                    provinceListTemp.push({
                        provinceName: item.ProvinceName,
                        provinceId: item.Id
                    })
                }
                preProvince = item.ProvinceName

                if (item?.CityId === response?.CityIdReservedOrReturned) {
                    cityProvinceTemp = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id,
                        provinceName: item?.ProvinceName
                    }
                }

            })
            handleInfoForm({
                cityAndProvinceList: listProvinceAndCity?.data,
                provinceList: provinceListTemp,
                cityProvince: cityProvinceTemp,
                provLoading: false
            })
            createCityList(listProvinceAndCity?.data, cityProvinceTemp)

        }
        catch (error) {
            handleInfoForm({
                provLoading: false
            })
            ErrorToast(error)
        }
    }

    const reservedInAccepInvoice = (item) => {
        if (item?.DescriptionReservedOrReturned) {
            let isExist = false;
            let temp = [...newReserveArr]

            let obj = {
                InvoiceNumberInFactor: lastFactorNumber + reserveCount + 1,
                InvoiceId: '',
                OfficialFactorType: 4,
                FinancialPeriodId: financialPeriodIdSelected,
                ReservedFactorDate: new Date(),
                BuyerNameReservedOrReturned: item?.BuyerNameReservedOrReturned,
                NationalCodeReservedOrReturned: item?.NationalCodeReservedOrReturned,
                DescriptionReservedOrReturned: item?.DescriptionReservedOrReturned,
                TotalAmountReservedOrReturned: item?.TotalAmountReservedOrReturned,
                AddressReservedOrReturned: item?.AddressReservedOrReturned,
                PhoneReservedOrReturned: item?.PhoneReservedOrReturned,
                ResidencePostalCodeReservedOrReturned: item?.ResidencePostalCodeReservedOrReturned,
                CityIdReservedOrReturned: item?.CityIdReservedOrReturned,
                FactorIssueType: item?.FactorIssueType,
                EmailReservedOrReturned: item?.EmailReservedOrReturned

            }
            temp.push(obj)
            setNewReserveArr(temp)

            let count = reserveCount
            setReserveCount(count + 1)
            insertReservedInvoiceFn(temp)
        }

        else {
            ErrorToast(constants.EmptyModal)
        }
    }

    const deleteInPendInvoice = () => {
        let tempChange = [...isChangeoption]
        tempChange.push(rowRejectedInPending)
        setIsChangeOption(tempChange)
        let temp = { ...data }
        temp.data[rowRejectedInPending].OfficialFactorType = 2
        temp.data[rowRejectedInPending].DescriptionReservedOrReturned = content
        temp.data[rowRejectedInPending].StatusEn = 'deleteRow'
        temp.data[rowRejectedInPending].Status = constants.RejectPend
        delete temp.data[rowRejectedInPending].InvoiceNumberInFactorFa
        delete temp.data[rowRejectedInPending].InvoiceNumberInFactor
        temp.data.forEach((item, index) => {
            if (item.idTable > rowRejectedInPending && item.OfficialFactorType !== 2) {
                item.InvoiceNumberInFactor = item.InvoiceNumberInFactor - 1
                item.InvoiceNumberInFactorFa = ToPersianNumber(item.InvoiceNumberInFactor)
            }
        })
        setData({ ...temp })
        setIsDeleted(false);
        setShow(false)
    }
    const reservedInPendInvoice = (item, id, isUpdate) => {
        let tempChange = [...isChangeoption]
        tempChange.push(rowReservedInPending)
        setIsChangeOption(tempChange)

        setShow(false)
        let temp = { ...data };
        let prevInvoiceNumberInFactor
        let dateOfCurrentRow

        if (isUpdate) {
            prevInvoiceNumberInFactor = temp.data[id].InvoiceNumberInFactor
            dateOfCurrentRow = temp.data[id]?.IssueDate
        }
        else {
            prevInvoiceNumberInFactor = temp.data?.length > rowReservedInPending + 1 ? temp.data[rowReservedInPending + 1].InvoiceNumberInFactor : (temp.data[rowReservedInPending].InvoiceNumberInFactor) + 1
            dateOfCurrentRow = temp.data?.length > rowReservedInPending + 1 ? temp.data[rowReservedInPending + 1].IssueDate : (temp.data[rowReservedInPending]?.IssueDate) + 1
        }



        let obj = {
            BuyerNameReservedOrReturned: item?.BuyerNameReservedOrReturned,
            NationalCodeReservedOrReturned: item?.NationalCodeReservedOrReturned,
            TotalAmountReservedOrReturned: item?.TotalAmountReservedOrReturned,
            AddressReservedOrReturned: item?.AddressReservedOrReturned,
            PhoneReservedOrReturned: item?.PhoneReservedOrReturned,
            ResidencePostalCodeReservedOrReturned: item?.ResidencePostalCodeReservedOrReturned,
            CityIdReservedOrReturned: item?.CityIdReservedOrReturned,
            FactorIssueType: item?.FactorIssueType,
            IssueDate: dateOfCurrentRow,
            PersianIssueDate: "",
            PayableAmount: 0,
            ContractDiscountAmount: null,
            FirstNameAndLastName: "---",
            EmailReservedOrReturned: item?.EmailReservedOrReturned,
            GatewayName: "---",
            InvoiceNumberInFactor: prevInvoiceNumberInFactor,
            InvoiceNumberInFactorFa: ToPersianNumber(prevInvoiceNumberInFactor),
            OfficialFactorType: 4,
            FinanicialPeriodId: null,
            OfficialFactorId: null,
            DescriptionReservedOrReturned: item?.DescriptionReservedOrReturned,
            Id: "",
            PayableAmountFa: '---',
            PersianIssueDateFa: "---",
            Status: constants.Reserved,
            StatusEn: 'ReservedInPending',
            idTable: isUpdate ? id : rowReservedInPending + 1,
            row: isUpdate ? ToPersianNumber(id + 1) : ToPersianNumber(rowReservedInPending + 2),
        }
        let currentId = isUpdate ? id : rowReservedInPending + 1
        if (!isUpdate) {
            // id of row reserved
            setIdOfNewRow(currentId)
            temp.data.splice(currentId, 0, obj);//add reser row

        }
        else {
            temp.data[currentId] = obj
        }
        if (!isUpdate) {
            temp.data.forEach((item, index) => {
                if (index > currentId) {
                    if (item.OfficialFactorType !== 2) {
                        let newValue = item.InvoiceNumberInFactor !== null && item.InvoiceNumberInFactor !== undefined ? item.InvoiceNumberInFactor + 1 : item.InvoiceNumberInFactor + 1
                        item.InvoiceNumberInFactor = newValue;
                        item.InvoiceNumberInFactorFa = item.InvoiceNumberInFactor ? ToPersianNumber(newValue) : newValue
                    }
                    item.row = ToPersianNumber(index + 1)
                    item.idTable = index
                }
            })
        }

        setData({ ...temp })
        setIsReserved(false)


    }

    const setRowBckReservedInPending = (idTable) => {
        let currentId = idTable
        let temp = { ...data }
        temp.data.splice(currentId, 1);
        temp.data.forEach((item, index) => {
            if (index >= currentId) {
                if (item.OfficialFactorType !== 2) {
                    let newValue = item.InvoiceNumberInFactor - 1
                    item.InvoiceNumberInFactor = newValue;
                    item.InvoiceNumberInFactorFa = ToPersianNumber(newValue)
                }
                item.row = ToPersianNumber(index + 1)
                item.idTable = index
            }
        })
        let tempChange = [...isChangeoption]
        tempChange.forEach((item, index) => {
            if (item === idTable - 1) {
                tempChange.splice(index, 1)
            }
        })
        setIsChangeOption(tempChange)
        setData({ ...temp })
    }
    //************************************************************************************************************** */
    const SVGDownloadFn = () => {
        setIsSVGDownload(true)
    }
    //************************************************************************************************************* */
    const handleClose = () => {
        setContent('')
        setTitle('')
        setIsNotSave(false)
        setShow(false)
        if (isChangeoption?.length > 0) {
            setviewDetail(false)
            setIsDeleted(false)
            setIsReserved(false)
            setIsApprove(false)
        }
    }
    //************************************************************************************************************* */
    const newInvoiceReserved = () => {
        setShowModalInfo(true)
        getProv()
        setNewresereved(true)
    }
    //************************************************************************************************************* */
    const changeValueModal = (e) => {
        setContent(e.target.value)
    }
    //************************************************************************************************************* */
    const notSaveFn = () => {
        setShow(false)
        setTitle(false)
        setContent(false)
        setIsNotSave(false)
        setIsReservedAddedtoeAcceptInvoice(false)
        setIsParameterChange(true)
        let temp = { ...data }
        temp.data = []
        setData({ ...temp })
        setIsChangeOption([])
        setStatusSelected(newOptionSelected)
    }
    const goToDownload = () => {
        setDownloadSCVFromPending(true)
    }
    const updateAcceptedStatus = (e) => {
        e.preventDefault()
        if (parseInt(statusSelected) === 4) {
            getReservedFactor()
        }
        else {
            handleGetNewStatus()
        }

        // 
    }

    const handleGetNewStatus = async () => {

        if (statusMovadianSelected === 'SUCCESS' || statusMovadianSelected === 'FAILED') {
            ErrorToast('به روز رسانی فقط برای فاکتورهای در حال بررسی امکان پذیر می باشد')
        }
        else {
            try {
                const dataInvoice = await getNewStatusAllMovadianInvoice({})
                handleGetData()
            }
            catch (error) {
                ErrorToast(error)
            }

        }

    }
    const handleChangeMovadian = (e) => {
        e.preventDefault()
        setStatusMovadianSelected(e.target.value)
        let myTemp = { ...data }
        if (e.target.value !== "all") {

            let temp = []
            data.data.forEach((item) => {
                if (e.target.value === 'PENDING') {
                    if (item.MoadianStatus === 'PENDING' || item.MoadianStatus === 'NOT_FOUND') {
                        temp.push(item)
                    }
                }
                else {
                    if (item.MoadianStatus === e.target.value) {
                        temp.push(item)
                    }
                }

            })
            myTemp.data = temp

        }
        setDataCopy({ ...myTemp })


    }
    return (
        <>
            <main className="invoice">
                <div className="top-margin"></div>
                <div className="user-info-container user-docs-container user-service-container ">
                    <div className="d-flex flex-row justify-content-between">
                        <div className="header-invoice-admin">
                            <div className="d-flex flex-row justify-content-start date-range-invoice-holder">
                                <LocalizationProvider
                                    dateAdapter={AdapterJalali}
                                    localeText={{ start: 'ازتاریخ', end: 'تا تاریخ' }}
                                >
                                    <DateRangePicker
                                        startText="از تاریخ"
                                        endText="تا تاریخ"
                                        maxDate={maxDate}
                                        value={value}
                                        onChange={(newValue) => {
                                            setValue(newValue);
                                        }}
                                        renderInput={(startProps, endProps) => (
                                            <React.Fragment>
                                                <TextField {...startProps} />
                                                <span style={{ dispaly: 'none !important', margin: '0 5px !important' }}></span>
                                                {/* <DateRangeDelimiter> to </DateRangeDelimiter>  */}
                                                <TextField {...endProps} />
                                            </React.Fragment>
                                        )}
                                    />
                                </LocalizationProvider>
                                <div className="status-invoice-holder">
                                    <select style={{ width: '160px', margin: '0 7px', padding: '0.45rem 0.77rem' }}
                                        onChange={(e) => handleChange(e)}
                                        className='form-control'
                                        value={statusSelected}
                                    >
                                        <option value={5} >{constants.PendingToAccept} </option>
                                        <option value={1} >{constants.Accepted} </option>
                                        <option value={2} >{constants.Rejected} </option>
                                        <option value={4} >{constants.Reserved}</option>
                                        <option value={3} >{constants.ReturnAndRevok}</option>
                                    </select>
                                    <span className="icon-selector-invoice-holder"><DrowpDown /></span>
                                </div>
                                {(parseInt(statusSelected) === 1 || parseInt(statusSelected) === 3) && <div className="status-invoice-holder">

                                    <select style={{ width: '160px', margin: '0 7px', padding: '0.45rem 0.77rem' }}
                                        onChange={(e) => handleChangeMovadian(e)}
                                        className='form-control'
                                        value={statusMovadianSelected}
                                    >
                                        <option value={'all'} >همه</option>
                                        <option value={'PENDING'} >در حال بررسی </option>
                                        <option value={'SUCCESS'} >تایید شده</option>
                                        <option value={'FAILED'} >رد شده</option>


                                    </select>
                                    <span className="icon-selector-invoice-holder"><DrowpDown /></span>
                                </div>}

                                <div>
                                    <button className="button-invoice-admin " onClick={(e) => handleSearch(e)} >جستجو</button>
                                </div>




                            </div>
                        </div>

                        {(parseInt(statusSelected) === 5 && (isCallApi || !isNotSave) && data?.data?.length > 0) && <button className="button-invoice-admin" onClick={goToDownload}>
                            {constants.DownloadCSV}
                        </button>}

                        {(parseInt(statusSelected) === 5 && (isCallApi || !isNotSave) && data?.data?.length > 0) && <button disabled={loading} className="button-invoice-admin" onClick={(e) => { inserDataFn(e) }}>
                            {loading ?
                                <div className="spinner-border" role="status" aria-hidden="true" ></div>
                                : constants.Approve}
                        </button>}

                        {parseInt(statusSelected) === 2 && !loading && data?.data?.length > 0 && isCallApi && <button className="button-invoice-admin" onClick={(e) => { CheckedAgainFn(e) }}>
                            {constants.CheckedAgain}
                        </button>}

                        {parseInt(statusSelected) === 1 && <button onClick={newInvoiceReserved} className="button-invoice-reserve-new">{constants.NewReserve}</button>}

                        {((parseInt(statusSelected) === 1 && data?.data?.length > 0 && isCallApi) || parseInt(statusSelected) === 3) && <button onClick={SVGDownloadFn} className="button-invoice-SVG-download">{constants.DownloadCSV}</button>}
                        {(parseInt(statusSelected) === 1 || parseInt(statusSelected) === 3 || parseInt(statusSelected) === 4) && <div>
                            <button className="button-invoice-admin " onClick={(e) => updateAcceptedStatus(e)} >به روز رسانی وضعیت</button>
                        </div>}
                    </div>
                    {data.data?.length > 0 && isexistFinacialYear && isGoodFinancialYear && <div className='d-flex flex-row justify-content-start'>
                        <div className="last-factor-number">
                            <span>{constants.LastFactor}:{lastFactorNumber !== '' && lastFactorNumber !== null ? ToPersianNumber(lastFactorNumber) : '--'}  </span>
                            <span>{constants.InDate}  </span>
                            <span>{lastFactorDate !== '' && lastFactorDate !== null ? DateToPersianNumber(lastFactorDate) : '--'}.  </span>
                            {(parseInt(statusSelected) === 5 || parseInt(statusSelected) === 1) && <span>{constants.TotalFactorListAmount}: </span>}
                            {(parseInt(statusSelected) === 5 || parseInt(statusSelected) === 1) && <span>{totalFactorListAmount !== '' && totalFactorListAmount !== null ? ToPersianNumber(CommaSeparator(totalFactorListAmount)) : '--'} </span>}
                            {(parseInt(statusSelected) === 5 || parseInt(statusSelected) === 1) && <span>{constants.Currency}</span>}
                        </div>
                    </div>}
                    {isGetRetuenRevoke && <GetReturnAndRevoke
                        setLastFactorNumber={setLastFactorNumber}
                        setLastFactorDate={setLastFactorDate}
                        setMessageEmpty={setMessageEmpty}
                        setData={setData}
                        data={statusMovadianSelected === 'all' ? data : dataCopy}
                        objGetData={objGetData}
                        value={value}
                        setLoading={setLoading}
                        loading={loading}
                        setItemInLoading={setItemInLoading}
                        itemInLoading={itemInLoading}
                        selectedStatus={statusSelected}
                        setItemForDownload={setItemForDownload}
                        setResendItemInLoading={setResendItemInLoading}
                        isGetRetuenRevoke={isGetRetuenRevoke}

                    />}

                    {(data?.data?.length > 0 || loading) && parseInt(statusSelected) !== 3 ?
                        <InvoiceTable
                            data={statusMovadianSelected === 'all' ? data : dataCopy}
                            setData={setDataCopy}
                            setOriginData={setData}
                            statusMovadianSelected={statusMovadianSelected}
                            originDataToPaging={states.originDataToPaging}
                            selectedStatus={statusSelected}
                            setColumns={setColumns}
                            loading={loading}
                            setRowReservedInPending={setRowReservedInPending}
                            setRowRejectedInPending={setRowRejectedInPending}
                            setIsReservedAddedtoeAcceptInvoice={setIsReservedAddedtoeAcceptInvoice}
                            setRowBckReservedInPending={setRowBckReservedInPending}
                            isReservedAddedtoeAcceptInvoice={isReservedAddedtoeAcceptInvoice}
                            setContent={setContent}
                            setTitle={setTitle}
                            setShow={setShow}
                            lastFactorNumber={lastFactorNumber}
                            setIdOfNewRow={setIdOfNewRow}
                            idOfNewRow={idOfNewRow}
                            setIsDeleted={setIsDeleted}
                            setIsReserved={setIsReserved}
                            setIsApprove={setIsApprove}
                            isDeleted={isDeleted}
                            isReserved={isReserved}
                            newReserved={newReserved}
                            // setSelectedForCheckAgain={setSelectedForCheckAgain}
                            setItemForDownload={setItemForDownload}
                            setviewDetail={setviewDetail}
                            checkedList={checkedList}
                            setCheckedList={setCheckedList}
                            setItemInLoading={setItemInLoading}
                            setResendItemInLoading={setResendItemInLoading}
                            itemInLoading={itemInLoading}
                            resendItemInLoading={resendItemInLoading}
                            reservedInPendInvoice={reservedInPendInvoice}


                        />
                        : ''
                    }
                    {data?.data?.length > 0 && isexistFinacialYear && isGoodFinancialYear && parseInt(statusSelected) === 5 && <div className='total-amount'>
                        <div className="d-flex flex-row justify-content-around">
                            <span>{constants.TotalPrice}:</span>
                            <span>{totalFactorListAmount !== '' && totalFactorListAmount !== null ? ToPersianNumber(CommaSeparator(totalFactorListAmount)) : '--'}{constants.Currency} </span>
                        </div>
                    </div>
                    }

                    {messageEmpty && <p className="no-exist-data">{constants.NoExitDataTitle}</p>}
                    {/* {data.data.length === 0  && isexistFinacialYear && isGoodFinancialYear && isCallApi && <p className="no-exist-data">{constants.NoExitDataTitle}</p>} */}
                    {data?.data?.length === 0 && !isexistFinacialYear && isGoodFinancialYear && <p className="no-exist-data">{constants.NotExistFinancialYear}</p>}
                    {data?.data?.length === 0 && !isexistFinacialYear && !isGoodFinancialYear && <p className="no-exist-data">{constants.NotGoodFinancialYear}</p>}

                    <Modal show={show} onHide={handleClose} animation={true} dir="rtl" className="invoice-modal">
                        <Modal.Header>
                            <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                                {title}
                                <img
                                    onClick={handleClose}
                                    alt={title !== '' ? title : '---'}
                                    src={btnClose}
                                />
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body className='invoice-modal-content-view'>
                            <>
                                {(isDeleted || isApprove || viewDetail || isChangeoption?.length > 0 || isCheckedAgain) && <textarea
                                    placeholder={`${content?.length < 10 && isDeleted
                                        ? 'دلیل رد کردن فاکتور را وارد نمایید (وارد کردن حداقل ده کاراکتر الزامی است)' :
                                        ''}`}
                                    disabled={(parseInt(statusSelected) !== 1 && parseInt(statusSelected) !== 5) || (isApprove)}
                                    className="textarea-reject-invoice"
                                    value={content}
                                    onChange={(e) => { changeValueModal(e) }}
                                />}

                            </>
                        </Modal.Body>


                        {parseInt(statusSelected) === 2 && isCheckedAgain && <Modal.Footer className="d-flex flex-row justify-content-center">
                            <button className="button-invoice-recheck" onClick={(e) => { chechAgain(e) }}>{constants.CheckedAgain}</button>
                        </Modal.Footer>}

                        {/* {(parseInt(statusSelected) === 1) && newReserved && <Modal.Footer className="d-flex flex-row justify-content-center">
                            <button className={`${content.length < 10 ? 'button-invoice-recheck-disable' : 'button-invoice-recheck'}`} disabled={content.length < 10} onClick={reservedInAccepInvoice}>{constants.ReservedNewFactor}</button>
                        </Modal.Footer>} */}

                        {parseInt(statusSelected) === 5 && isDeleted && <Modal.Footer className="d-flex flex-row justify-content-center">
                            <button className={`${content?.length < 10 ? 'button-invoice-recheck-disable' : 'button-invoice-recheck'}`} disabled={content?.length < 10} onClick={deleteInPendInvoice}>{constants.ApproveDelete}</button>
                        </Modal.Footer>}

                        {/* {parseInt(statusSelected) === 5 && isReserved && <Modal.Footer className="d-flex flex-row justify-content-center">
                            <button className={`${content.length < 10 ? 'button-invoice-recheck-disable' : 'button-invoice-recheck'}`} disabled={content.length < 10} onClick={reservedInPendInvoice}>{constants.ApproveReserved}</button>
                        </Modal.Footer>} */}

                        {parseInt(statusSelected) === 5 && isApprove && <Modal.Footer className="d-flex flex-row justify-content-center">
                            <button onClick={(e) => { approveInvoice(e) }} className='button-invoice-approve'>{constants.Approve}</button>
                        </Modal.Footer>}

                        {/* && !isReserved && !isDeleted && !viewDetail
                         */}

                        {isChangeoption?.length > 0 && isNotSave && <Modal.Footer className="d-flex flex-row justify-content-between">
                            <button className="button-invoice-confirm-save" onClick={handleClose}>{'بله'}</button>
                            <button className="button-invoice-confirm-save" onClick={notSaveFn}>{'خیر'}</button>
                        </Modal.Footer>}
                    </Modal>

                    {isSVGDownload && <DownloadSCV data={data} setIsSVGDownload={setIsSVGDownload} />}
                    {downloadSCVFromPending && <DownloadSCVFromPending data={data} setDownloadSCVFromPending={setDownloadSCVFromPending} />}

                    {showModalInfo && <ModalInfo
                        fromPage="newReserve"
                        showModalInfo={showModalInfo}
                        setShowModalInfo={setShowModalInfo}
                        reservedInAccepInvoice={reservedInAccepInvoice}
                        createCityList={createCityList}
                        infoForm={infoForm}
                        handleInfoForm={handleInfoForm}

                    />}
                </div>
            </main>
        </>
    )
}

export default InvoicelList